import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, null, -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nama"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Nomor Telepon"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Posisi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Keterangan")
  ])
], -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "row mt-5 mb-5" }
const _hoisted_20 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_21 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_22 = ["label", "value"]
const _hoisted_23 = { class: "p-3" }
const _hoisted_24 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_25 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control w-250px ps-15",
            placeholder: "Cari Nama",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
            onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePageSize(_ctx.e)))
          }, null, 544), [
            [_vModelText, _ctx.name]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          (_ctx.tableData.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(item.name), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.email), 1),
                    _createElementVNode("td", _hoisted_13, _toDisplayString(item.phone), 1),
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.position), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(item.note), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_16, _hoisted_18))
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", null, [
              _withDirectives(_createElementVNode("select", {
                name: "kt_customers_table_length",
                class: "form-select form-select-sm form-select-solid",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paging.size) = $event)),
                placeholder: "Per page",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changePageSize()))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: item,
                    label: item,
                    value: item
                  }, null, 8, _hoisted_22))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.paging.size]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("ul", _hoisted_25, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                style: {"cursor":"pointer"},
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
              }, " Previous ")
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
            }, [
              _createElementVNode("a", {
                class: "page-link",
                style: {"cursor":"pointer"},
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
              }, " Next ")
            ], 2)
          ])
        ])
      ])
    ])
  ], 2))
}